export enum S1AuthMode {
    WINDOWS = 0,
    STRATEGYONE = 1,
    OAUTH2 = 2
    //EXTERNAL = 2 not required in BAC
}